// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORM_EXIT_ARE_YOU_SURE = "Obsah formul\u00e1\u0159e bude smaz\u00e1n, sis jist\u00e1, \u017ee chce\u0161 pokra\u010dovat?";
export const NOT_LOGGED_IN = "Nejsi p\u0159ihl\u00e1\u0161en\u00e1";
export const TOAST_ERRORS_IN_FORM = "Formul\u00e1\u0159 se nepoda\u0159ilo odeslat. N\u011bkde v n\u011bm m\u00e1\u0161 chybu.";
